import { X } from 'lucide-react';
import { SPACING } from '../../lib/design-tokens';

/**
 * DetailDrawer — Rechter detail-paneel (split view)
 *
 * Sticky aan de rechterkant van de pagina.
 * Gebruik voor: risico-detail, asset-detail, maatregel-detail.
 *
 * @param {boolean}          open      - Of de drawer zichtbaar is
 * @param {function}         onClose   - Sluit handler
 * @param {React.ReactNode}  header    - Drawer header content (badges, titel)
 * @param {React.ReactNode}  children  - Body content
 * @param {React.ReactNode}  footer    - Footer met acties
 * @param {string}           testId
 */
export const DetailDrawer = ({ open, onClose, header, children, footer, testId = 'detail-drawer' }) => {
  if (!open) return null;
  return (
    <div className={`${SPACING.drawerW} shrink-0 border-l border-neutral-200 bg-white h-screen sticky top-0 overflow-y-auto`} data-testid={testId}>
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="flex items-start justify-between p-4 border-b border-neutral-200 bg-neutral-50/50">
          <div className="flex-1 min-w-0">{header}</div>
          <button
            onClick={onClose}
            className="ml-2 h-7 w-7 rounded-md border border-neutral-200 flex items-center justify-center hover:bg-neutral-100 shrink-0"
            data-testid={`${testId}-close`}
          >
            <X className="h-3.5 w-3.5 text-neutral-500" strokeWidth={1.5} />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="p-3 border-t border-neutral-200 bg-neutral-50/50 flex items-center gap-2">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};
